export const playlistViewerTitles = Object.freeze({
  playlists: 'Playlists',
  'loop-playlists': 'Looped Playlists',
  'weekly-playlists': 'Weekly Playlists',
});

export const playlistTitles = Object.freeze({
  playlists: 'Playlist',
  'loop-playlists': 'Looped Playlist',
  'weekly-playlists': 'Weekly Playlist',
});
